import { IconProps } from ".";
import Icon from "./assets/doc_attach.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24DocAttach(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
